<template lang="pug">
  h1 You are not authorized to view this page.
</template>

<script>
  export default {
    name: 'Unauthorized'
  };
</script>

<style scoped>
  h1 {
    text-align: center;
  }
</style>
